var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.4 0C2.4174 0 0 2.07943 0 4.64505V21.1608C0 23.7264 2.4174 25.8058 5.4 25.8058H18.6C21.5826 25.8058 24 23.7264 24 21.1608V10.3223H15.6C13.6116 10.3223 12 8.93604 12 7.22563V0H5.4ZM14.4 0.177415V7.22563C14.4 7.79594 14.9376 8.25786 15.6 8.25786H23.7938L14.4 0.177415Z",
    fill: "#3B457B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1c459c2db582b66ec9a2fa1354b66df2.svg";
export { ForwardRef as ReactComponent };